import { HttpContext, HttpContextToken } from '@angular/common/http';

export const OMIT_HTTP_ERROR_CODES_ACTION = new HttpContextToken<number[]>(
  () => []
);

export const createNewOmitHttpErrorCodesContext = (action: number[]) => {
  return new HttpContext().set(OMIT_HTTP_ERROR_CODES_ACTION, action);
};
